import React, { useState } from "react";
import Popup from "reactjs-popup";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import axios from "axios";
import '../styles/pages/ModalLoan.css';

function FixedDepositeModal({ refreshData }) {
  const [open, setOpen] = useState(false);
  const [eligibility, setEligibility] = useState("");
  const [features, setFeatures] = useState([]);
  const [interestRate, setInterestRate] = useState("");
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchContent = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/fixed-account");
      if (res.data) {
        setEligibility(res.data.eligibility || "");
        setFeatures(res.data.features || []);
        setInterestRate(res.data.interestRate || "");
        setDocuments(res.data.documents || []);
      }
    } catch (err) {
      console.error("Error fetching content", err);
    }
    setLoading(false);
  };

  const toggleModal = () => {
    if (!open) fetchContent();
    setOpen(!open);
  };

  const handleFeatureChange = (index, value) => {
    const updatedFeatures = [...features];
    updatedFeatures[index] = value;
    setFeatures(updatedFeatures);
  };

  const addFeature = () => setFeatures([...features, ""]);
 const removeFeature = async (index) => {
  if (window.confirm("Are you sure you want to delete this feature?")) {
    try {
      // Send delete request to the proxy route
      await axios.delete(`/api/fixed-account/feature/${index}`);
      refreshData(); // Refresh data after delete to reflect the changes
    } catch (err) {
      console.error("Error deleting feature", err);
      alert("Failed to delete feature, please try again later.");
    }
  }
};

  const handleDocumentChange = (index, value) => {
    const updatedDocuments = [...documents];
    updatedDocuments[index] = value;
    setDocuments(updatedDocuments);
  };

  const addDocument = () => setDocuments([...documents, ""]);
  const removeDocument = async (index) => {
  console.log('Attempting to delete document at index:', index);
  if (window.confirm("Are you sure you want to delete this document?")) {
    setLoading(true);
    try {
      await axios.delete(`/api/fixed-account/document/${index}`);
      setDocuments(documents.filter((_, i) => i !== index)); // Update the UI after deletion
      refreshData(); // Refresh data after delete
    } catch (err) {
      console.error("Error deleting document", err);
      alert("Failed to delete the document. Please try again.");
    }
    setLoading(false);
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post("/api/fixed-account", {
        eligibility,
        features,
        interestRate,
        documents,
      });
      alert("Content updated successfully!");
      refreshData(); // Refresh data after update
      toggleModal();
    } catch (err) {
      alert("Error saving content");
    }
    setLoading(false);
  };

  return (
    <div className="modalDiv">
      <FaEdit className="icon-button" onClick={toggleModal} />

      <Popup
        open={open}
        closeOnDocumentClick={false}
        contentStyle={{
          overflowY: 'auto',
          maxHeight: '80vh',
          padding: '20px',
          width: '500px',
        }}
      >
        <a className="close" onClick={toggleModal}>
          &times;
        </a>
        <h3>Edit Fixed Deposite Content</h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={eligibility}
            onChange={(e) => setEligibility(e.target.value)}
            placeholder="Eligibility"
            required
            style={{ width: "100%", marginBottom: "10px" }}
          />

          <div>
            <h4>Features & Benefits</h4>
            {features.map((feature, index) => (
              <div key={index} style={{ marginBottom: "10px" }}>
                <input
                  type="text"
                  value={feature}
                  onChange={(e) => handleFeatureChange(index, e.target.value)}
                  placeholder={`Feature ${index + 1}`}
                />
                {features.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeFeature(index)}
                  >
                    <FaTrash /> Delete
                  </button>
                )}
              </div>
            ))}
            <button type="button" onClick={addFeature}>
              <FaPlus /> Add Feature
            </button>
          </div>

          <div>
            <h4>Officially Valid Documents</h4>
            {documents.map((doc, index) => (
              <div key={index} style={{ marginBottom: "10px" }}>
                <input
                  type="text"
                  value={doc}
                  onChange={(e) => handleDocumentChange(index, e.target.value)}
                  placeholder={`Document ${index + 1}`}
                />
                {documents.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeDocument(index)}
                  >
                    <FaTrash /> Delete
                  </button>
                )}
              </div>
            ))}
            <button type="button" onClick={addDocument}>
              <FaPlus /> Add Document
            </button>
          </div>

         

          <button type="submit" disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>
        </form>
      </Popup>
    </div>
  );
}

export default FixedDepositeModal;
